import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import React from 'react'
import BenefitCard from './BenefitCard'

const styles = () => ({
  sectionSubContainer: {
    padding: '24px',
    position: 'relative',
    overflow: 'none'
  }
})

const PureDesktopBenefitsView = ({ classes, setSectionActive, sections }) => (
  <Grid
    className={classes.sectionSubContainer}
    container
    direction="row"
    justify="center"
    wrap="nowrap"
    alignItems="flex-start"
    spacing={2}
  >
    {sections.map((benefit, index) => (
      <Grid key={benefit.id} item>
        <BenefitCard
          index={index}
          onClick={setSectionActive}
          section={benefit}
          {...benefit}
        />
      </Grid>
    ))}
  </Grid>
)

const DesktopBenefitsView = withStyles(styles)(PureDesktopBenefitsView)

export default DesktopBenefitsView
